@if (items().length === 0) {
  <div class="empty-state border border-primary rounded-large surface-primary">
    <div
      class="empty-state__layer flex flex--column flex--middle g-xsmall ps-medium align-center"
      [class.empty-state__layer--hidden]="loading()"
    >
      <fcom-icon
        [name]="SvgLibraryIcon.CALENDAR"
        class="icon-medium nordic-blue-900-text text-icon-primary"
        aria-hidden="true"
      />
      <div class="nordic-blue-900-text text-icon-primary font-body-medium">
        {{ (originCode() && destinationCode() ? 'timetable.flightList.noFlights' : selectDateKey()) | finLocalization }}
      </div>
    </div>
    <div class="empty-state__layer flex flex--center flex--middle" [class.empty-state__layer--hidden]="!loading()">
      <fcom-loader [loaderType]="LoaderTheme.EMBEDDED" spacingClass="" />
    </div>
  </div>
}

@if (items().length) {
  <ul class="unstyled flex flex--column g-xsmall pr-xlarge-b">
    @for (item of items(); track item) {
      <li>
        <button
          type="button"
          aria-haspopup="dialog"
          class="schedule-item fill align-left flex flex--middle flex--space-between ps-medium-y pr-xsmall-x border border-primary rounded-large surface-primary text-icon-primary"
          (click)="openModal(item)"
        >
          <span class="is-vishidden">
            {{
              'timetable.flightSummaryDetails'
                | finLocalization
                  : {
                      origin: (item.origin$ | async) ?? '',
                      departureTime: item.departureTime,
                      destination: (item.destination$ | async) ?? '',
                      arrivalTime: item.arrivalTime,
                      durationTime: item.duration.hours + 'h ' + item.duration.minutes + 'min',
                    }
            }}
          </span>
          <span class="flex flex--middle flex--space-between fill g-xsmall" aria-hidden="true">
            <span class="flight-column overflow-hidden flex flex--column g-xsmall">
              @for (flight of item.flights; track $index) {
                <span class="overflow-hidden flex flex--middle g-xsmall">
                  <span class="flex--nogrow tail {{ flight.tailClass }}" aria-hidden="true"></span>
                  <span class="overflow-hidden truncate nordic-blue-900-text text-icon-primary font-body-medium">{{
                    flight.flightNumber
                  }}</span>
                </span>
              }
            </span>
            <span class="times-grid flex-2 flex--basis0 flex--middle g-xsmall ps-medium-r">
              @for (flight of item.flights; track $index) {
                <span class="times-row">
                  <span class="nordic-blue-900-text text-icon-primary font-label-medium">
                    {{ flight.departureTime }}
                  </span>
                  <fcom-icon [name]="flight.icon" class="flex--nogrow" aria-hidden="true" />
                  <span class="relative nordic-blue-900-text text-icon-primary font-label-medium">
                    {{ flight.arrivalTime }}
                    @if (flight.overnight) {
                      <span
                        class="absolute nordic-blue-900-text text-icon-primary ps-xxsmall-l plus-one font-body-small"
                      >
                        +1
                      </span>
                    }
                  </span>
                </span>
              }
            </span>
            <span class="flex-1 flex--basis0 flex flex--middle">
              <span class="nowrap nordic-blue-900-text text-icon-primary font-body-medium">
                {{ item.duration.hours + 'h ' + item.duration.minutes + 'min' }}
              </span>
            </span>
            <span class="flex flex--middle flex--end">
              <span
                class="dn-mobile db-tablet-up nordic-blue-900-text text-icon-primary blue-light-hover underline font-label-medium"
              >
                {{ 'timetable.viewDetails' | finLocalization }}
              </span>
              <fcom-icon [name]="SvgLibraryIcon.CHEVRON_RIGHT" class="flex--nogrow flex--middle" aria-hidden="true" />
            </span>
          </span>
        </button>
      </li>
    }
  </ul>
}

<fcom-modal
  [title]="'timetable.flightList.viewDetails.title' | finLocalization"
  [buttons]="null"
  [(open)]="detailsModalOpen"
  (close)="closeModal()"
>
  @if (selectedBound(); as bound) {
    <fin-itinerary-timeline
      [bound]="bound"
      [locations]="locations()"
      [boundType]="BoundType.outbound"
      class="block pr-medium"
    />
  }
</fcom-modal>
